import {TurnState} from "@/api/TurnApi.ts";
import {useRealtimeChannel} from "@/api/realtime/RealtimeChannelHooks.ts";

export function useTurnRealtime(encounterId: string) {
    const {subscribe, onConnected} = useRealtimeChannel<TurnState>(`/encounters/${encounterId}/turn`);
    return {subscribeToUpdates: subscribe, onConnected};
}
